<template>
  <Col class="iv-common-block" :span="span">
    <CommonTitle :icon="formItem.icon" :main="formItem.main" :text="formItem.text" @more="moreClick(formItem)" />
    <div class="iv-m-t-20 iv-new-infocon" v-if="formItem.type == 'mix'">
      <dl
        v-for="(item, inx) in formItem.list.slice(0, 1)"
        :key="formItem.code + '' + item.code + '' + inx"
      >
        <dt class="iv-m-r-20 iv-pointer" @click="onDetail(item)"><img :src="getImgPath(item.blogPic)" @error="nofind"/></dt>
        <dd>
          <h3 :title="item.title" class="iv-fs-16 iv-fw-b iv-fc-85 iv-p-t-12 iv-pointer iv-hover-color iv-ellipsis-2" @click="onDetail(item)">
            {{ item.title }}
          </h3>
          <p :title="item.desc" class="iv-fs-14 iv-fc-65 iv-m-t-8 iv-pointer iv-hover-color iv-ellipsis-3" @click="onDetail(item)">
            {{ item.desc }}
          </p>
        </dd>
      </dl>
      <ul
        v-for="(item, inx) in formItem.list.slice(1, 4)"
        :key="formItem.code + '' + item.code + '' + (inx + 1)"
      >
        <li class="iv-p-t-16 iv-p-b-16">
          <IconFont type="caret-right" class="iv-fs-12 iv-fc-65 iv-m-r-12"></IconFont>
          <p :title="item.title" class="iv-fs-16 iv-fc-85 iv-pointer iv-hover-color iv-ellipsis-1" @click="onDetail(item)">
            {{ item.title }}
          </p>
          <span class="iv-fs-14 iv-fc-45">{{ timeFormat(item.publisTime, 'yyyy-MM-dd') }}</span>
        </li>
      </ul>
    </div>
    <div class="iv-m-t-20 iv-new-infocon" v-if="formItem.type == 'text'">
      <ul
        v-for="(item, inx) in formItem.list.slice(0, 6)"
        :key="formItem.code + '' + item.code + '' + (inx + 1)"
      >
        <li class="iv-p-t-16 iv-p-b-16">
          <IconFont type="caret-right" class="iv-fs-12 iv-fc-65 iv-m-r-12"></IconFont>
          <p :title="item.title" class="iv-fs-16 iv-fc-85 iv-pointer iv-hover-color iv-ellipsis-1" @click="onDetail(item)">
            {{ item.title }}
          </p>
          <span class="iv-fs-14 iv-fc-45">{{ timeFormat(item.publisTime, 'yyyy-MM-dd') }}</span>
        </li>
      </ul>
    </div>
    <div class="iv-m-t-20 iv-new-infocon" v-if="formItem.type == 'img'">
      <dl
        v-for="(item, inx) in formItem.list.slice(0, 2)"
        :key="formItem.code + '' + item.code + '' + inx"
        class="iv-img-dl"
      >
        <dt class="iv-m-r-20 iv-pointer" @click="onDetail(item)"><img :src="getImgPath(item.blogPic)" @error="nofind"/></dt>
        <dd>
          <h3 :title="item.title" class="iv-fs-16 iv-fw-b iv-fc-85 iv-p-t-12 iv-pointer iv-hover-color iv-ellipsis-2" @click="onDetail(item)">
            {{ item.title }}
          </h3>
          <p :title="item.desc" class="iv-fs-14 iv-fc-65 iv-m-t-8 iv-pointer iv-hover-color iv-ellipsis-3" @click="onDetail(item)">
            {{ item.desc }}
          </p>
        </dd>
      </dl>
    </div>
  </Col>
</template>
<script>
import IconFont from '@/components/iconfont'
import CommonTitle from './common-title'
import { timeFormat } from '@/utils'
export default {
  components: { CommonTitle, IconFont },
  props: {
    type: {
      type: String,
      default: 'mix' // text,img,mix
    },
    span: {
      type: String,
      default: '12'
    },
    formItem: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {}
  },
  created () {},
  methods: {
    timeFormat,
    moreClick (item) {
      this.$emit('moreClick', item)
    },
    onDetail (item) {
      this.$emit('onDetail', item)
    },
    getImgPath(imageUrl) {
      return process.env.VUE_APP_BASE_DOWNLOAD_IMAGE_API + imageUrl
    },
    nofind () {
      var img = event.srcElement
      img.src = require('@/assets/images/new-home/static/img2.png')
      img.onerror = null
    }
  }
}
</script>

<style lang="scss" scoped>
.iv-common-block {
  padding: 40px 0;
  width: calc(50% - 20px);
}
.iv-new-infocon {
  dl {
    padding-bottom: 20px;
    overflow: hidden;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
    &.iv-img-dl {
      border-bottom: none;
      &:last-child {
        padding-bottom: 0;
      }
    }
    dt {
      width: 248px;
      height: 100%;
      img {
        width: 100%;
        vertical-align: middle;
      }
      float: left;
    }
    dd {
      width: calc(100% - 268px);
      float: right;
      h3 {
        max-height: 60px;
        overflow: hidden;
      }
      p {
        max-height: 66px;
        overflow: hidden;
      }
    }
  }
  ul {
    li {
      border-bottom: 1px dashed rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      span {
        margin-left: auto;
      }
      p {
        width: calc(100% - 105px);
        max-height: 24px;
        overflow: hidden;
      }
    }
  }
}
</style>